import { Helmet } from 'react-helmet-async';
import ServicePage from './ServicePage';
import { useService } from '../hooks/usePublicApi';
import { serviceCategories } from '../data/services';

const staticData = serviceCategories.find((s) => s.id === 'umbau');

export default function Umbau() {
  const { service } = useService('umbau');
  const data = service || staticData;

  return (
    <>
      <Helmet>
        <title>Umbau & Modernisierung | Süd Ausbau GmbH</title>
        <meta name="description" content="Umbau und Modernisierung bestehender Räumlichkeiten in München. Neue Raumkonzepte und optimierte Grundrisse — Süd Ausbau GmbH." />
      </Helmet>
      <ServicePage data={data} />
    </>
  );
}
